module.exports = "/images/flag_brazil.png?2118b9746cf72dbe479b7aeaac733f96";